<template>

  <div class="mien">
    <div class="banner">
      <img src="../../assets/img/blur_bg@2x.8ef7a0fa.jpg">
    </div>
    <div class="mien-container container-width">
      <div class="achievement">
      </div>
      <ul class="mien-list">
        <li class="mien-item">
          <p class="mien-pic">
            <a href="https://mp.weixin.qq.com/s/GUmuzUiXuDE4FQYnUxvJ-w"
               target="_blank">
              <img src="../../assets/img/2023_9_8_1.4dcda70d.jpg" alt="海豹信息参加厦门市第五届网络安全宣传周开幕式，倡导网络安全共守护">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="https://mp.weixin.qq.com/s/GUmuzUiXuDE4FQYnUxvJ-w"
                   target="_blank">
                  海豹信息参加厦门市第五届网络安全宣传周开幕式，倡导网络安全共守护
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                聚焦网络安全知识的宣传，共话厦门市网络安全建设的成果，9月5日，厦门市第五届网络安全宣传周重磅开幕。
              </p>
            </div>
            <p class="mien-time">
              2023/09/07
              <a href="https://mp.weixin.qq.com/s/GUmuzUiXuDE4FQYnUxvJ-w"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="http://tech.china.com.cn/roll/20230906/398773.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_2.eee17adf.jpg" alt="海豹他趣联合集美特教学校举办义卖活动 关怀特殊儿童成长">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="http://tech.china.com.cn/roll/20230906/398773.shtml"
                   target="_blank">
                  海豹他趣联合集美特教学校举办义卖活动 关怀特殊儿童成长
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                2023年9月5日，中华慈善日前夕，厦门海豹他趣信息技术股份有限公司联合厦门市集美区特殊教育学校的师生们在灌口万达举办“晴天下”爱心义卖活动，通过售卖集美区特殊教育学校学生们的手工艺品，帮助特殊儿童获得更好的教育资源与成长空间，吸引了众多市民和关注特殊教育事业的人士前来参与。
              </p>
            </div>
            <p class="mien-time">
              2023/09/05
              <a href="http://tech.china.com.cn/roll/20230906/398773.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="https://hea.china.com/hea/20230801/202308011385964.html"
               target="_blank">
              <img src="../../assets/img/2023_9_8_3.9c2ca4e8.png" alt="【狂欢交友】极美•Super音乐市集，他趣助力青年花式脱单">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="https://hea.china.com/hea/20230801/202308011385964.html"
                   target="_blank">
                  【狂欢交友】极美•Super音乐市集，他趣助力青年花式脱单
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                他趣联合举办极美•Super音乐市集，助力青年花式脱单
              </p>
            </div>
            <p class="mien-time">
              2023/07/27
              <a href="https://hea.china.com/hea/20230801/202308011385964.html"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="http://tech.china.com.cn/roll/20230703/397338.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_4.a861870a.jpg" alt="【七一建党节】追溯红路，继往开来——他趣党支部参访古田旧址">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="http://tech.china.com.cn/roll/20230703/397338.shtml"
                   target="_blank">
                  【七一建党节】追溯红路，继往开来——他趣党支部参访古田旧址
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                为庆祝中国共产党成立102周年，回顾党的光辉历程，同时推动主题教育走深走实、见行见效，在“七一”建党节之际，他趣开展主题教育红色访学活动，由他趣党支部书记、创始人黄俊杰带队，带领公司党员、团员和工会职工等十余人，参访“古田会议旧址”。
              </p>
            </div>
            <p class="mien-time">
              2023/07/01
              <a href="http://tech.china.com.cn/roll/20230703/397338.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="https://www.toutiao.com/article/7181663117171130892/"
               target="_blank">
              <img src="../../assets/img/2023_9_8_5.5d585403.png" alt="喜报！他趣荣获“厦门青年五四奖章集体”称号">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="https://www.toutiao.com/article/7181663117171130892/"
                   target="_blank">
                  喜报！他趣荣获“厦门青年五四奖章集体”称号
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                6月27日，共青团厦门市委、厦门市青年联合会决定，授予一批青年集体、个人“厦门青年五四奖章集体”“厦门青年五四奖章标兵”“厦门青年五四奖章个人”荣誉称号。共有21个集体、42名个人获奖。海豹他趣子公司——厦门她趣信息技术有限公司荣获“厦门青年五四奖章集体”称号。
              </p>
            </div>
            <p class="mien-time">
              2023/06/29
              <a href="https://www.toutiao.com/article/7181663117171130892/"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="http://tech.china.com.cn/roll/20230614/396917.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_6.3e8ad768.png" alt="他趣获聘“厦门市纪委监委营商环境监督联系点”">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="http://tech.china.com.cn/roll/20230614/396917.shtml"
                   target="_blank">
                  他趣获聘“厦门市纪委监委营商环境监督联系点”
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                一纸聘书，承一肩责任，共同助力厦门营商环境持续优化——经厦门市纪委监委确定，他趣获聘“厦门市纪委监委营商环境监督联系点”。
              </p>
            </div>
            <p class="mien-time">
              2023/06/14
              <a href="http://tech.china.com.cn/roll/20230614/396917.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="https://news.pedaily.cn/20230605/59735.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_7.b79b0540.png" alt="中国品牌日活动在沪开幕—他趣亮相国家级盛宴">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="https://news.pedaily.cn/20230605/59735.shtml"
                   target="_blank">
                  中国品牌日活动在沪开幕—他趣亮相国家级盛宴
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                “走出去”拥抱广阔市场，“飞出去”迎接发展机遇，在厦门市相关部门的组织和推介下，厦门海豹他趣信息技术股份有限公司积极参展，开展商务交流活动。2023年5月，第七个中国品牌日如约而至。由国家发改委联合相关部门主办的2023年中国品牌日活动在上海开幕。活动以“中国品牌，世界共享”为主题，以“品牌新力量，品质新生活”为年度主题，45个厦门自主品牌集结亮相，展示厦门品牌发展新成果新形象，向世界递出“厦门名片”。
              </p>
            </div>
            <p class="mien-time">
              2023/06/05
              <a href="https://news.pedaily.cn/20230605/59735.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="http://tech.china.com.cn/roll/20230531/396595.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_8.ef9eacb5.png" alt="“微”爱接力！他趣全国助残日爱心捐款关爱特教学生">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="http://tech.china.com.cn/roll/20230531/396595.shtml"
                   target="_blank">
                  “微”爱接力！他趣全国助残日爱心捐款关爱特教学生
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                2023年5月21日是第33个“全国助残日”。为发扬慈善公益的无私精神，支持特殊教育学生获得更好的教育与照护，厦门海豹他趣信息技术股份有限公司在第三十三个助残日到来之际，于5月12日上午受邀来到集美区特殊教育学校开展了爱心捐款活动。在他趣党支部与工会的号召下，公司党员、员工踊跃伸出援助之手，慷慨解囊，献出爱心，用实际行动表达了对特教学生们的帮助。
              </p>
            </div>
            <p class="mien-time">
              2023/05/31
              <a href="http://tech.china.com.cn/roll/20230531/396595.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>
        <li class="mien-item">
          <p class="mien-pic">
            <a href="https://www.cinn.cn/pinpaizhiliang/202305/t20230524_269187.shtml"
               target="_blank">
              <img src="../../assets/img/2023_9_8_9.1656db65.png" alt="海豹他趣彰显品牌实力 倡导年轻人追求真爱">
            </a>
          </p>
          <div class="mien-content">
            <div class="mien-text">
              <p class="mien-title ellipsis-multi">
                <a href="https://www.cinn.cn/pinpaizhiliang/202305/t20230524_269187.shtml"
                   target="_blank">
                  海豹他趣彰显品牌实力 倡导年轻人追求真爱
                </a>
              </p>
              <p class="mien-subtitle ellipsis-multi">
                以“品牌新力量，品质新生活”为主题的中国品牌日，前不久在上海落下帷幕。45个厦门自主品牌集结亮相，展示厦门品牌发展新成果新形象，向世界递出“厦门名片”。海豹他趣应邀参展，为参展者献上了一场视觉盛宴，生动诠释了厦门品牌魅力
              </p>
            </div>
            <p class="mien-time">
              2023/05/24
              <a href="https://www.cinn.cn/pinpaizhiliang/202305/t20230524_269187.shtml"
                 target="_blank">
                查看详情
              </a>
            </p>
          </div>
        </li>



      </ul>
    </div>
  </div>


</template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .mien-container{
    padding-top:60px;
    width:982px
  }
  .container-width {
    width:982px;
    margin:0 auto
  }

  .achievement{
    background:url(../../assets/img/img_jiangpai.f7695dc1.png) 50% no-repeat;
    padding:5px;
    height:540px;
    background-size:contain
  }
  .mien-list{
    padding:80px 28px
  }
  .mien-item{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    padding-bottom:40px
  }
  .mien-pic{
    width:268px;
    -ms-flex-negative:0;
    flex-shrink:0;
    max-height:160px;
    overflow:hidden;
    text-align:center
  }
  .mien-content{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    padding:4px 0 10px 25px;
    -webkit-box-flex:1;
    -ms-flex:1;
    flex:1
  }
  .mien-title{
    color:#282121;
    line-height:25px;
    font-size:19px
  }
  .mien-title a{
    color:#282121
  }
  .mien-subtitle{
    color:rgba(0,0,0,.55);
    font-size:14px;
    line-height:20px;
    padding-top:16px
  }
  .mien-time{
    color:rgba(0,0,0,.36);
    line-height:20px;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    padding-top:6px
  }
  .mien-time a{
    color:rgba(0,0,0,.36);
    position:relative;
    padding-right:14px
  }
  
  .mien-time a:before {
    width:8px;
    height:8px;
    position:absolute;
    right:2px;
    top:6px;
    content:"";
    border-top:1px solid rgba(0,0,0,.36);
    border-right:1px solid rgba(0,0,0,.36);
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    -webkit-transform:rotate(45deg);
    -ms-transform:rotate(45deg);
    transform:rotate(45deg)
  }



</style>



// WEBPACK FOOTER //
// src/views/Mien.vue